"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("./typography");
var grid_1 = require("./grid");
var layout_1 = require("../util/layout");
var questions = [
    {
        q: 'Is Hank a retirement home?',
        a: 'Hank is not a retirement home, but rather a new option for senior living. We provide all of the day-to-day help, activities, and community to keep you independent and engaged in the home you already love.',
    },
    {
        q: 'How can I contact you?',
        a: 'You can contact us by email at <a href="mailto:hello@gethank.com">hello@gethank.com</a> or by phone at <a href="tel:+18554295369">855-429-5369</a> Monday-Friday from 10 AM - 5 PM Eastern. We would love to hear from you! Members who sign up for a plan get a dedicated phone number for all of their needs.',
    },
    {
        q: 'What do I get by signing up for Hank?',
        a: 'Hank provides all of the services and amenities you need to live independently at home. Hank members can schedule services like meal delivery, transportation, and more! Included in your subscription is access to our growing library of videos and games, as well as our online community with live events and video calls.',
    },
    {
        q: 'How much does Hank cost?',
        a: 'Hank costs $19.99 per month which includes unlimited access to videos and games. Tasks such as grocery delivery, rides, and home cleaning can be scheduled for an additional charge, depending on the task.',
    },
    {
        q: 'Which areas do you serve?',
        a: 'We provide service in all 50 states. Availability of specific services varies by region. Please sign up to check service availability in your area.',
    },
    {
        q: 'Who performs the tasks scheduled through Hank?',
        a: 'We partner with a network of national service providers to ensure quality and safety no matter where you are.',
    },
    {
        q: 'Is Hank safe to use during the Covid-19 pandemic?',
        a: 'Yes, we use contactless delivery for all our orders, so your loved one can maintain a safe distance from your delivery person.',
    },
    {
        q: 'How does my loved one place an order?',
        a: 'Members receive a dedicated support phone number where they can call or text us to place an order. ',
    },
    {
        q: 'Does my loved one need a smartphone or computer to order?',
        a: 'No, anyone can place an order by calling or texting us at our members-only service number.',
    },
    {
        q: 'Can I request services for someone else?',
        a: 'Yes, Hank is designed to allow anyone to schedule services on behalf of a loved one.',
    },
    {
        q: 'Can I set an order schedule in advance?',
        a: 'Yes, you can set your order to repeat automatically so tasks are scheduled ahead of time.',
    },
    {
        q: 'What happens if I have a problem with an order?',
        a: 'You can call, text, or email us at any time and we will be able to assist you with your order.',
    },
];
var AccordionItemStyle = (0, styled_components_1.default)(grid_1.Item)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:not(:last-of-type) {\n    border-bottom: 1px solid #dddddc;\n  }\n"], ["\n  &:not(:last-of-type) {\n    border-bottom: 1px solid #dddddc;\n  }\n"])));
var Animate = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  transition: all 0.35s ease;\n  overflow: hidden;\n  line-height: ", ";\n  padding-bottom: ", ";\n  opacity: ", ";\n"], ["\n  transition: all 0.35s ease;\n  overflow: hidden;\n  line-height: ", ";\n  padding-bottom: ", ";\n  opacity: ", ";\n"])), function (_a) {
    var expanded = _a.expanded;
    return (expanded ? 1.2 : 0);
}, function (_a) {
    var expanded = _a.expanded;
    return (expanded ? (0, layout_1.space)(2) : 0);
}, function (_a) {
    var expanded = _a.expanded;
    return (expanded ? 1 : 0);
});
var FAQItem = function (_a) {
    var question = _a.question, answer = _a.answer, num = _a.num;
    var _b = (0, react_1.useState)(false), expanded = _b[0], toggleOpen = _b[1];
    var toggle = function () { return toggleOpen(!expanded); };
    return (react_1.default.createElement(AccordionItemStyle, { cols: 12 },
        react_1.default.createElement(typography_1.P, { weight: 700, py: 2, onClick: toggle, onKeyDown: toggle, role: "button", style: { cursor: 'pointer' }, name: "FAQ Item ".concat(num) }, question),
        react_1.default.createElement(Animate, { expanded: expanded },
            react_1.default.createElement(typography_1.P, { dangerouslySetInnerHTML: { __html: answer } }))));
};
var FAQ = function (_a) {
    var _b = _a.title, title = _b === void 0 ? 'Frequent questions' : _b, _c = _a.questionsOnly, questionsOnly = _c === void 0 ? false : _c;
    var inner = (react_1.default.createElement(react_1.default.Fragment, null, questions.map(function (question, idx) { return (react_1.default.createElement(FAQItem, { key: "faq-".concat(idx), question: question.q, answer: question.a, num: idx + 1 })); })));
    if (questionsOnly)
        return inner;
    return (react_1.default.createElement(grid_1.LayoutWrapper, { py: 8 },
        react_1.default.createElement(grid_1.Container, { center: true, direction: "column" },
            react_1.default.createElement(typography_1.H3, { center: true, pb: 3, weight: 700 }, title),
            inner)));
};
exports.default = FAQ;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FAQ.js.map